import { Helmet } from 'react-helmet';
import './references.style.scss'
import { ContainerComponent, ImageSwiper, ParagraphComponent, SubtitleComponent, TitleComponent, VideoPlayer } from '../../components';
import { Trans, useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player'

import p1 from '../../assets/images/references/pero/p1.webp';
import p2 from '../../assets/images/references/pero/p2.webp';
import p3 from '../../assets/images/references/pero/p3.jpg';
import p4 from '../../assets/images/references/pero/p4.webp';
import p6 from '../../assets/images/references/pero/p6.png';
import p7 from '../../assets/images/references/pero/p7.webp';
import p8 from '../../assets/images/references/pero/p8.png';
import p9 from '../../assets/images/references/pero/p9.jpg';
import p10 from '../../assets/images/references/pero/p10.png';

import { useVideoStore } from '../../store';
import { useEffect, useRef } from 'react';

function ReferencePero() {
  const { t, i18n } = useTranslation();
  const { currentVideo, videos } = useVideoStore();


  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => { videoRef.current && videoRef.current.scrollIntoView({ behavior: "smooth", block: "end" },) });


  return (
    <>
      <div className="referencePlinara" >
        <Helmet>
          <title>{t('pero.meta.title')}</title>
          <meta name="description" content={t('pero.meta.description')} />
        </Helmet>
        <ContainerComponent>
          <Trans>
            <h1><TitleComponent centered smaller style={{ marginTop: '3rem' }}>{t('pero.title')}</TitleComponent></h1>
            <h3><SubtitleComponent>{t('pero.subtitle')}</SubtitleComponent></h3>
            <ReactPlayer className="videoPlayer" playing={true} controls={true} autoPlay muted={true} url={'https://www.youtube.com/shorts/rdcrTWRJ3bw'} />

          </Trans>
        <ImageSwiper images={[p2, p1, p3,p4,p6,p7,p8,p9,p10]} thumbs />

          <Trans>
            <div className="specifications">
              <h3><SubtitleComponent medium white large semiBold>{t('pero.specifications.title')}</SubtitleComponent></h3>
              <ParagraphComponent>{t('pero.specifications.content')}</ParagraphComponent>
            </div>
            
          </Trans>
        </ContainerComponent >
      </div >
    </>
  )
}

export default ReferencePero